.homeWrapper {
    display: flex;
    flex-flow: column nowrap;
    gap: var(--exo-spacing-standard);
}

.sectionBox {
    border: 1px solid var(--exo-color-border-secondary);
    border-radius: var(--exo-radius-large);
    padding: var(--exo-spacing-standard) var(--exo-spacing-medium);
    background: var(--exo-color-background);
}

.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: var(--exo-spacing-standard);
}

.recentHeading,
.allConnectorsHeading {
    font-size: var(--exo-font-size-x-small);
    font-weight: var(--exo-font-weight-semi-bold);
    color: var(--exo-color-font);
}

.recentHeading {
    margin: 0;
}

.allConnectorsHeading {
    margin-top: var(--exo-spacing-small);
    margin-bottom: var(--exo-spacing-large);
}

.actions {
    display: flex;
    align-items: center;
    gap: var(--exo-spacing-small);
}

.emptyTitle {
    margin: 40px 0;
    font-size: 15px;
    font-weight: var(--exo-font-weight-bold);
    text-align: center;
    color: var(--exo-color-font);
}

.cardRow {
    display: flex;
    flex-wrap: wrap;
    gap: var(--exo-spacing-small);
}

.cardWrap {
    width: 180px;
    flex-shrink: 0;
}

.allConnectorsCardRow {
    /* Auto-scaling grid setup with a maximum number of columns per row. 
    Based on https://youtu.be/CHULPvkXIRo?si=-lbli2OSxzILNjnv */
    --gap-size: var(--exo-spacing-small);
    --max-column-count: 8;
    /* Available horizontal space to fill with columns, accounting for space used by the gap. 
    Number of gaps will always be one less than the number of columns (due to them appearing only between columns). */
    --horizontal-space: calc(100% - (var(--gap-size) * (var(--max-column-count) - 1)));
    /* Available horizontal space divided by the target number of columns per row, creating a per-column width value that will always allow at most N=max-column-count columns per row. */
    --max-column-size: calc(var(--horizontal-space) / var(--max-column-count));
    /* The largest of max-column-size (when there is space for N=max-column-count columns) or 170px (when there is not enough room). If 170px would cause overflow, fallback to 100% of the available space. */
    --min-column-size: min(max(170px, var(--max-column-size)), 100%);
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(var(--min-column-size), 1fr));
    gap: var(--gap-size);
}

.noResults {
    margin-top: var(--exo-spacing-medium);
    display: flex;
    justify-content: center;
}

.idpSetupAlert {
    display: flex;
    margin-bottom: var(--exo-spacing-medium);
}

.idpSetupBody {
    display: flex;
    align-items: center;
    gap: var(--exo-spacing-medium);
    height: var(--exo-spacing-large);
}

.idpSetupText {
    font-size: var(--exo-font-size-x-small);
}

.search {
    width: 400px;
}

.filterRow {
    display: flex;
    align-items: center;
    gap: var(--exo-spacing-x-small);
    margin-bottom: var(--exo-spacing-medium);
}
